import { Checkbox } from '@nesso/ui/primitives/checkbox';
import { CommandItem } from '@nesso/ui/primitives/command';

type Props = {
    value: string;
    label: string;
    isSelected: boolean;
    isDisabled: boolean;
    onToggle: (value: string) => void;
};

export function MultiSelectItem({ value, label, isSelected, isDisabled, onToggle }: Props) {
    return (
        <CommandItem
            value={value}
            onSelect={() => onToggle(value)}
            disabled={isDisabled}
            className="h-9"
        >
            <Checkbox checked={isSelected} disabled={isDisabled} />
            <span className="truncate leading-6">{label}</span>
        </CommandItem>
    );
}
